export function convertIntObj(obj) {
  const res = {}
  for (const key in obj) {
    res[key] = {};

    const parsed = parseInt(obj[key], 10);
    res[key] = isNaN(parsed) ? obj[key] : parsed;
  }
  return res;
}
